import { api } from "../api";

/**
 * checkListTypesFindAllByActivated - Function that finds on database all checklist types
 * /checklist/types 
 * method GET 
 * @async-function
 */
const checkListTypesFindAllByActivated = async (token: string, status: string) => {
    const response = await api.get(
        `/checklists/types/${status}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default checkListTypesFindAllByActivated;